// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.IRP_profile__34WMH {\n  margin-top: 24px; }\n", ""]);
// Exports
exports.locals = {
	"profile": "IRP_profile__34WMH"
};
module.exports = exports;
